import { JsonObject, JsonProperty } from 'json2typescript';
import { UserStatistics } from './user-statistics.model';
import { UserCurrency } from './user-currency.model';
import { UserBooster } from './user-booster.model';
import { UserSession } from './user-session.model';
import { UserAccountType } from '../../enums/users/user-account-type.enum';
import { UserGender } from '../../enums/users/user-gender.enum';
import { UserCurrencyType } from '../../enums/users/user-currency-type.enum';

@JsonObject('User')
export class User {

  @JsonProperty('user_id', Number)
  userId: number = 0;

  @JsonProperty('email', String)
  email: string = '';

  @JsonProperty('firstname', String)
  firstname: string = '';

  @JsonProperty('locale', String)
  locale: string = '';

  @JsonProperty('account_type', Number)
  accountType: UserAccountType = UserAccountType.Guest;

  @JsonProperty('avatar_image', String)
  avatarImage: string = '';

  @JsonProperty('gender', Number)
  gender: UserGender = UserGender.Unspecified;

  @JsonProperty('experience_level', Number)
  experienceLevel: number = 0;

  @JsonProperty('experience_point', Number)
  experiencePoint: number = 0;

  @JsonProperty('experience_next_level_point', Number)
  experienceNextLevelPoint: number = 0;

  @JsonProperty('free_credits_base_quantity', Number)
  freeCreditsBaseQuantity: number = 0;

  @JsonProperty('free_credits_available_timestamp', Number)
  freeCreditsAvailableTimestamp: number = 0;

  @JsonProperty('hammer_update_time', Number)
  hammerUpdateTime: number = 0;

  @JsonProperty('is_tutorial_complete', Boolean)
  isTutorialComplete: boolean = false;

  @JsonProperty('shop_buy_items_count', Number)
  shopBuyItemsCount: number = 0;

  @JsonProperty('shop_buy_price_total', Number)
  shopBuyPriceTotal: number = 0;

  @JsonProperty('shop_buy_credits', Number)
  shopBuyCredits: number = 0;

  @JsonProperty('statistics', UserStatistics)
  statistics: UserStatistics = new UserStatistics();

  @JsonProperty('created_at_timestamp', Number)
  createdAtTimestamp: number = 0;

  @JsonProperty('delete_date_timestamp', Number)
  deleteDateTimestamp: number = 0;

  @JsonProperty('is_deleted', Boolean)
  isDeleted: boolean = false;

  @JsonProperty('is_banned', Boolean)
  isBanned: boolean = false;

  @JsonProperty('currencies', [UserCurrency])
  currencies: UserCurrency[] = [];

  @JsonProperty('shop_buy_last_date_timestamp', Number)
  shopBuyLastDateTimestamp: number = 0;

  @JsonProperty('boosters', [UserBooster])
  boosters: UserBooster[] = [];

  @JsonProperty('session', UserSession)
  session: UserSession = new UserSession();

  isOnline(): boolean {
    if (!this.session?.createTimeTimestamp) return false;
    return (Math.floor(Date.now() / 1000) - this.session.createTimeTimestamp) < 7200;
  }

  getCurrencyQuantity(type: UserCurrencyType, ticketCost: number = 0): number {
    const currency = this.currencies.find(c => c.currencyType === type && (ticketCost === 0 || c.currencyTicketCost === ticketCost));
    if (!currency) return 0;
    return ticketCost > 0 ? currency.currencyTicketCost : currency.currencyQuantity;
  }
}
